/**
 * CartIcon — sanitized from `assets/newSvg/cart.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function CartIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M9,20 C9.55228,20 10,20.4477 10,21 C10,21.5523 9.55228,22 9,22 C8.44772,22 8,21.5523 8,21 C8,20.4477 8.44772,20 9,20 Z M16,20 C16.5523,20 17,20.4477 17,21 C17,21.5523 16.5523,22 16,22 C15.4477,22 15,21.5523 15,21 C15,20.4477 15.4477,20 16,20 Z M2.20006,2.90006 C2.50594,2.49221692 3.06354734,2.38454994 3.4950344,2.63103054 L3.60006,2.70006 L5.30781,3.98087 C5.60023286,4.20018714 5.82529163,4.4941198 5.96118481,4.82919165 L6.0216,5.00000086 L18.8672,5.00000086 C20.020075,5.00000086 20.9229608,5.96832722 20.8648834,7.09964823 L20.8518,7.24807 L20.3948,10.9035 C20.1110581,13.1740161 18.3255992,14.9517331 16.0752465,15.2420619 L15.8487,15.2661 L8.53605,15.8755 L8.79557,17.0001 L17.5001,17.0001 C18.0523,17.0001 18.5001,17.4478 18.5001,18.0001 C18.5001,18.5128571 18.1139867,18.9355959 17.6167055,18.9933711 L17.5001,19.0001 L8.79557,19.0001 C7.91904294,19.0001 7.15169235,18.4306107 6.8898623,17.6071067 L6.84679,17.4498 L4.10781,5.58087 L2.40006,4.30006 C1.95823,3.96869 1.86869,3.34189 2.20006,2.90006 Z"
        fill={color}
      />
    </Svg>
  );
}

export default CartIcon;
